<div class="row" *ngIf="noticeLocation !== 'login'">
    <div class="col-md-12" *ngFor="let notice of notices">
        <mat-card class="mat-card {{notice.type}} mb-s" *ngIf="showNotice(notice.filter)">
            <mat-card-content>
                <div class="row d-flex">
                    <div class="col-md-1 text-center my-auto h2 pb-0" [ngClass]="notice.type">
                        <span [className]="(notice.type == 'warn') ? 'fa fa-exclamation-circle warn' : 'fa fa-info-circle info'"></span>
                    </div>
                    <div class="col-md-11" [innerHTML]="notice.text"></div>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
</div>

<div *ngIf="noticeLocation === 'login'">
    <div *ngFor="let notice of notices">
        <mat-card class="mb-l no-shadow" *ngIf="showNotice(notice.filter)">
            <mat-card-content>
                <div class="row justify-content-center">
                    <div class="col-md-1 text-center">
                        <i [className]="(notice.type == 'warn') ? 'fal fa-5x fa-exclamation-circle warn' : 'fal fa-5x fa-info-circle info'"></i>
                    </div>
                    <div class="col-md-11">
                        <div class="{{notice.type}}" [innerHTML]="notice.text"></div>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
</div>

